import { useEffect } from 'react'

export const loadScript = (src, onload) => {
  useEffect(() => {
    if (document.querySelector(`script[src="${src}"]`)) {
      onload?.()
    } else {
      document.head.appendChild(Object.assign(document.createElement('script'), { onload, src }))
    }
  }, [src])
}
